module.exports = __webpack_public_path__ + "img/kf.208dd22e.jpg";